module.exports = __webpack_public_path__ + "img/family-6.7fb58c80.jpg";